import React from "react";
import ArraySettingEditor from "./ArraySettingEditor";
import ObjectSettingEditor from "./ObjectSettingEditor";
import FormulaSettingEditor from "./FormulaSettingEditor";
import CommissionIndicatorsEditor from "./CommissionIndicatorsEditor";

export default function SettingEditor({ setting, allSettings = [] }) {
  if (!setting) return null;

  const type = String(setting.settings_type || "").toLowerCase();

  if (type === "formula") {
    return <FormulaSettingEditor setting={setting} allSettings={allSettings} />;
  }

  if (type === "commission_bands") {
    return <CommissionIndicatorsEditor setting={setting} />;
  }

  // "options" / "menu" are legacy aliases used by older settings rows (e.g. job)
  if (type === "array" || type === "options" || type === "menu") {
    return (
      <ArraySettingEditor setting={setting} allSettings={allSettings} />
    );
  }

  if (type === "object") {
    return (
      <ObjectSettingEditor setting={setting} allSettings={allSettings} />
    );
  }

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
      نوع تنظیم «{setting.settings_type || "نامشخص"}» پشتیبانی نشده است.
      برای ویرایش فرمی، `settings_type` باید یکی از مقادیر
      <code className="mx-1">object</code>،
      <code className="mx-1">array</code>،
      <code className="mx-1">formula</code>
      یا
      <code className="mx-1">commission_bands</code> باشد.
    </div>
  );
}
